// extracted by mini-css-extract-plugin
export default {"platformCardContainer":"PlatformCard_platformCardContainer__ifDQM","name":"PlatformCard_name__utbfU","line":"PlatformCard_line__H17lE"};